import { EventEmitter, SimpleChanges } from '@angular/core';
import { CallListModel } from '@apto/models';
import './current-lists-card.scss';
import { AlertController, ModalController } from 'ionic-angular';
import { Subject } from 'rxjs';
import { CallListModal, CallListModalMode, TasksModal, TasksModalMode } from '@apto/shared/modals';
import { Router } from '@angular/router';
var CurrentListsCard = /** @class */ /*@__PURE__*/ (function () {
    function CurrentListsCard(alertController, modalController, router) {
        var _this = this;
        this.alertController = alertController;
        this.modalController = modalController;
        this.router = router;
        this.contacts = [];
        this.editEnabled = true;
        this.removeFromList = new EventEmitter();
        this.callLists = [];
        this.contactCallLists = [];
        this.otherCallLists = [];
        this.modalCallListsData = new Subject();
        this.subscriptions = [];
        this.modalRef = null;
        this.emitRemoveFromList = function (event, callList) {
            event.stopPropagation();
            if (_this.curCallList &&
                _this.contacts &&
                _this.contacts[0] &&
                !_this.curCallList.members.find(function (el) { return el.contact._id !== _this.contacts[0]._id && !el.callResult; }) &&
                _this.curCallList._id == callList._id &&
                _this.modalRef) {
                _this.modalRef.dismiss();
            }
            _this.removeFromList.emit(callList);
        };
    }
    Object.defineProperty(CurrentListsCard.prototype, "someCallListIsPending", {
        get: function () {
            return this.callLists.find(function (callList) {
                return callList.isPending;
            });
        },
        enumerable: true,
        configurable: true
    });
    CurrentListsCard.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); });
    };
    CurrentListsCard.prototype.ngOnChanges = function (changes) {
        if (changes.callLists || changes.contacts) {
            this.getCallLists();
            this.modalCallListsData.next(this.contactCallLists);
        }
    };
    CurrentListsCard.prototype.getCallLists = function () {
        var _this = this;
        this.contactCallLists = this.callLists.filter(function (callList) {
            if (callList.type !== CallListModel.TYPE.CONTACT_GROUP_LIST) {
                return false;
            }
            var includesContact = (callList.members || []).some(function (callListMember) {
                return callListMember.contactId === _this.contacts[0]._id;
            });
            return includesContact || callList.isPending;
        });
        this.otherCallLists = this.callLists.filter(function (cl) { return !_this.contactCallLists.includes(cl); });
    };
    CurrentListsCard.prototype.viewAllCallLists = function () {
        this.modalRef = this.modalController.create(CallListModal, {
            callLists: this.contactCallLists,
            modalCallListsData: this.modalCallListsData,
            emitRemoveFromList: this.emitRemoveFromList,
        });
        this.modalRef.present({ updateUrl: false });
    };
    CurrentListsCard.prototype.viewCallList = function (callList) {
        var _this = this;
        var modalClass = callList.isTaskList ? TasksModal : CallListModal;
        var mode = callList.isTaskList ? TasksModalMode.LIST : CallListModalMode.VIEW;
        this.modalRef = this.modalController.create(modalClass, {
            callList: callList,
            mode: mode,
            tasks: callList.tasks,
            title: callList.name
        });
        if (!callList.isTaskList) {
            this.modalRef.onDidDismiss(function (data) {
                if (data && data.selectedContact && data.selectedContact._id) {
                    _this.router.navigate(['/call-lists', callList._id, data.selectedContact._id]);
                }
            });
        }
        this.modalRef.present({ updateUrl: false });
    };
    return CurrentListsCard;
}());
export { CurrentListsCard };
